import React, { useEffect, useRef, useState } from "react";
import { FileText, FileWarning, Loader2 } from "lucide-react";
import { fileType, getThumb } from "../lib/attachments";

export function FileThumb({ dossierId, file, className = "w-full h-full", testid }) {
  const ref = useRef(null);
  const [src, setSrc] = useState(undefined);
  const [visible, setVisible] = useState(false);
  const type = fileType(file);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const io = new IntersectionObserver(([e]) => e.isIntersecting && setVisible(true), { rootMargin: "200px" });
    io.observe(el);
    return () => io.disconnect();
  }, []);

  useEffect(() => {
    if (!visible || type === "other") return;
    let alive = true;
    getThumb(dossierId, file).then((s) => alive && setSrc(s)).catch(() => alive && setSrc(null));
    return () => { alive = false; };
  }, [visible, dossierId, file, type]);

  return (
    <div ref={ref} className={`relative overflow-hidden bg-norea-surfaceHover flex items-center justify-center ${className}`} data-testid={testid}>
      {type === "other" ? (
        <div className="flex flex-col items-center gap-1 text-norea-textMuted"><FileWarning className="w-5 h-5" /><span className="text-[9px] uppercase">{(file.filename || "").split(".").pop()}</span></div>
      ) : src ? (
        <img src={src} alt={file.filename} className="w-full h-full object-cover object-top" draggable={false} />
      ) : src === null ? (
        <FileText className="w-5 h-5 text-norea-textMuted" />
      ) : (
        <Loader2 className="w-4 h-4 animate-spin text-norea-textDisabled" />
      )}
      {type === "pdf" && <span className="absolute bottom-1 right-1 text-[8px] font-bold px-1 rounded bg-orange-600 text-white">PDF</span>}
    </div>
  );
}
